import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMegaphone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22.844,
	height: 25.974,
	viewBox: "0 0 22.844 25.974",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "megaphone",
		transform: "translate(-30.849)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_11784",
				"data-name": "Group 11784",
				transform: "translate(30.849 0.969)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_11783",
					"data-name": "Group 11783",
					transform: "translate(0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_69233",
						"data-name": "Path 69233",
						d: "M51.96,28.372l-8.607-8.607a2.282,2.282,0,0,0-3.506,2.891l-.012.06a15.924,15.924,0,0,1-4.369,8.163l-3.948,3.948a2.281,2.281,0,0,0,0,3.228l2.152,2.152a2.281,2.281,0,0,0,3.228,0l.538-.538L41.2,43.434a2.282,2.282,0,0,0,3.228-3.228l-1.614-1.614.538-.538a2.281,2.281,0,0,0,0-3.228l-.366-.366a15.927,15.927,0,0,1,6.022-2.572l.061-.012a2.285,2.285,0,0,0,2.89-.278h0A2.285,2.285,0,0,0,51.96,28.372ZM35.822,39.13a.76.76,0,0,1-1.076,0l-2.152-2.152a.76.76,0,0,1,0-1.076l3.765-3.765,3.228,3.228Zm7.531,2.152a.761.761,0,1,1-1.076,1.076l-3.765-3.765,1.076-1.076Zm-2.69-4.841c.229-.229.571-.579,1.111-1.04l.5.5a.76.76,0,0,1,0,1.076l-.538.538Zm.032-2.119L37.4,31.029a17.421,17.421,0,0,0,3.7-7.055l6.643,6.643A17.42,17.42,0,0,0,40.7,34.321Zm10.188-3.8a.76.76,0,0,1-1.076,0L41.2,21.917a.761.761,0,0,1,1.076-1.076l8.607,8.607A.762.762,0,0,1,50.884,30.523Z",
						transform: "translate(-30.849 -19.098)",
						fill: "currentColor"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_11786",
				"data-name": "Group 11786",
				transform: "translate(34.523 16.475)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_11785",
					"data-name": "Group 11785",
					transform: "translate(0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_69234",
						"data-name": "Path 69234",
						d: "M105.64,324.985a.761.761,0,0,0-1.076,0l-1.076,1.076a.761.761,0,0,0,1.076,1.076l1.076-1.076A.761.761,0,0,0,105.64,324.985Z",
						transform: "translate(-103.266 -324.762)",
						fill: "currentColor"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_11788",
				"data-name": "Group 11788",
				transform: "translate(46.086)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_11787",
					"data-name": "Group 11787",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_69235",
						"data-name": "Path 69235",
						d: "M331.955,0a.761.761,0,0,0-.761.761V2.282a.761.761,0,1,0,1.521,0V.761A.761.761,0,0,0,331.955,0Z",
						transform: "translate(-331.194)",
						fill: "currentColor"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_11790",
				"data-name": "Group 11790",
				transform: "translate(50.65 6.086)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_11789",
					"data-name": "Group 11789",
					transform: "translate(0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_69236",
						"data-name": "Path 69236",
						d: "M423.451,119.966H421.93a.761.761,0,0,0,0,1.521h1.521a.761.761,0,0,0,0-1.521Z",
						transform: "translate(-421.169 -119.966)",
						fill: "currentColor"
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_11792",
				"data-name": "Group 11792",
				transform: "translate(49.129 1.521)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_11791",
					"data-name": "Group 11791",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_69237",
						"data-name": "Path 69237",
						d: "M394,30.214a.761.761,0,0,0-1.076,0L391.4,31.735a.761.761,0,1,0,1.076,1.076L394,31.29A.761.761,0,0,0,394,30.214Z",
						transform: "translate(-391.178 -29.991)",
						fill: "currentColor"
					})
				})
			})
		]
	})
});
export default SvgMegaphone;
